import React from 'react';

interface QuestionsWritingProps {
  Container: React.FC;
  WhiteBackCard: React.FC;
}

const QuestionsWriting: React.FC<QuestionsWritingProps> = ({
  Container,
  WhiteBackCard,
}) => {
  return (
    <Container>
      <WhiteBackCard />
    </Container>
  );
};

export default QuestionsWriting;
